export const LOGO_CACHE_KEY = 'vb_logo_config';

export function normalizeLogo(logo) {
  if (!logo || typeof logo !== 'object') return null;
  const imageUrl = logo.imageUrl || null;
  const mode = logo.mode === 'image' && imageUrl ? 'image' : 'text';
  const text = logo.text || '';
  // Reject empty text logos with no image — treat as missing
  if (mode === 'text' && !text) return null;
  return {
    mode,
    imageUrl,
    text,
    textSize: Number(logo.textSize) || 22,
    textStyle: logo.textStyle === 'normal' ? 'normal' : 'italic',
    alt: logo.alt || '',
    siteName: logo.siteName || '',
  };
}

export function readCachedLogo() {
  // Prefer sessionStorage first (same as preloader), then localStorage
  for (const storeName of ['sessionStorage', 'localStorage']) {
    try {
      const raw = window[storeName]?.getItem(LOGO_CACHE_KEY);
      if (!raw) continue;
      const logo = normalizeLogo(JSON.parse(raw));
      if (logo) return logo;
    } catch {
      /* try next */
    }
  }
  return null;
}

export function writeCachedLogo(logo) {
  const normalized = normalizeLogo(logo);
  if (!normalized) return;
  const raw = JSON.stringify(normalized);
  for (const storeName of ['sessionStorage', 'localStorage']) {
    try {
      window[storeName]?.setItem(LOGO_CACHE_KEY, raw);
    } catch {
      /* ignore quota / private mode */
    }
  }
}
